import ArrowLeft from '@mui/icons-material/ChevronLeft';
import { Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { useIsWidthUp } from '../utils';

const styles = {
    backButtonNavbar: {
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
    },
};
const NavigateBackBar = (props) => {
    const { label, url, labelDescription, maxLabelLength, labelStyle, backButtonNavbarStyle } = props;
    const isSmallScreen = !useIsWidthUp('sm');
    const history = useHistory();

    return (
        <div style={{ 
            maxWidth: '95%', 
            overflowX: 'auto',
            paddingTop: isSmallScreen ? '1.15rem' : '1rem',
            paddingRight: '1rem',
            paddingBottom: '1rem',
            paddingLeft: '1rem',
            ...(styles.backButtonNavbar), 
            ...(backButtonNavbarStyle) 
        }}>
            <Tooltip title="Back">
                <ArrowLeft style={{ color: '#007AFF', cursor: 'pointer' }} onClick={() => history.push(url)} />
            </Tooltip>
            {maxLabelLength ? (
                <Tooltip
                    title={label.length > maxLabelLength ? label : ''}
                    PopperProps={{
                        sx: {
                            maxWidth: isSmallScreen ? '100% !important' : 'none', // Remove max width restriction
                            zIndex: 10000000000, // Set z-index to be on top of everything
                        },
                    }}
                    componentsProps={{
                        tooltip: {
                            sx: {
                                whiteSpace: isSmallScreen ? 'auto' : 'nowrap',
                                maxWidth: isSmallScreen ? '100% !important' : 'none', // Remove max width restriction
                                zIndex: 10000000000, // Set z-index to be on top of everything

                            },
                        },
                    }}>
                    <Typography 
                        style={{ 
                            marginLeft: '0.25rem', 
                            whiteSpace: 'nowrap', 
                            fontWeight: '500',
                            paddingTop: '0.1rem',
                            ...labelStyle,
                        }} 
                    >
                        {label.length > maxLabelLength ? label.substr(0, maxLabelLength) + '...' : label}
                    </Typography>
                </Tooltip>
            ) : (
                <Typography style={{ marginLeft: '0.25rem', whiteSpace: 'nowrap', fontWeight: '300', paddingTop: '0.1rem', ...labelStyle }}>
                    {labelDescription && <b>{labelDescription}:</b>} {label}
                </Typography>
            )}
        </div>
    );
};

export default NavigateBackBar;
